export default function splitDateAndTimeFromIsoDateTime(isoString) {
  return isoString.replace(/Z|\+01:00/gi, '').split('T');
}
